import { useEffect, useState } from 'react';
export var Clock = function Clock(props) {
  var _useState = useState(new Date().toLocaleTimeString()),
      time = _useState[0],
      setTime = _useState[1];

  useEffect(function () {
    var tick = function tick() {
      var now = new Date();
      setTime(now.toLocaleTimeString());
    };

    var timer = setInterval(tick, 1000);
    return function () {
      clearInterval(timer);
    };
  }, []);
  return time;
};
export default Clock;